import React from 'react';
import PropTypes from 'prop-types';
import DataTable from '../../../../components/DataTable';
import Title from '../../../../components/Title';
import FilterBar from './FilterBar';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const uri = '/service/v1/health/clinics';

const initialParams = {
  sort: 'az',
};

function Clinics() {
  const [params, setParams] = React.useState(initialParams);

  function handleFilter(parms) {
    setParams({ ...initialParams, ...parms });
  }

  const tableHeaders = [
    { name: 'id_clinic', label: 'ID' },
    { name: 'name', label: 'Nombre' },
    { name: 'phone_number', label: 'Teléfono' },
    { name: 'url_web', label: 'Página web' },
  ];

  return (
    <>
      <Title variant="h5" component="h2">Clínicas</Title>
      <DataTable
        uri={uri}
        params={params}
        headers={tableHeaders}
        filters={<FilterBar onFilter={handleFilter} />}
      />
    </>
  );
}

Clinics.propTypes = propTypes;

export default Clinics;
